import { TreeAccount_Set } from '../../../generated/mlmbox/types/account';

export function formatString(s: string): string {
    return s.padStart(6, '0');
}

export function filledTreeAccountsList(treeAccountsList: TreeAccount_Set[]): TreeAccount_Set[] {
    const resultValue: TreeAccount_Set[] = [];

    [...new Array(15)].map((_, index) => {
        let result: TreeAccount_Set | null = null;
        treeAccountsList.map((el) => {
            if (index + 1 === el.treeId && el.entity?.treeAccountEntityId) {
                result = el;
            }
        });

        if (result) {
            resultValue.push(result);
        } else {
            resultValue.push({
                treeId: index + 1,
                quantity: 0,
                activatedQuantity: 0,
                activatedCapacity: 0,
                poolValue: '0',
                bookingQuantity: 0,
                entity: {
                    filled: false,
                    treeEntityId: 0,
                    filled2W2LBitMask: 0,
                    positionId: 0,
                    treeAccountEntityId: 0,
                    treeChainId: 0,
                    viewAccess: false,
                },
            });
        }
    });

    return resultValue;
}
